import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import { Columns } from '../../components/atoms/Columns'
import { Port } from '../../types/models'
import { OptimizerPricePort, OptimizerPriceConfig, PortConfigOptimizerPrice } from '../../types/ports'
import { lang } from '../../utils/lang'
import { DeviceControl } from '../DeviceControl'
import { PortControl } from './PortControl'

/**
 * Controller for optimizer control.
 */
export class OptimizerPricePortControl extends PortControl<OptimizerPricePort, OptimizerPriceConfig> {

  port: OptimizerPricePort

  constructor(deviceControl: DeviceControl, port: Port) {
    super(deviceControl, port)
    this.port = port as OptimizerPricePort
  }

  get isBuying(): boolean { return this.port.port_number === '212/0' }

  get group(): string { return this.app.t('PortGroup-Optimization') }

  getTypeName(): string { return this.isBuying ? this.app.t('PortType-Optimizer Buy Price') : this.app.t('PortType-Optimizer Sell Price') }

  getDescription(): string {
    return this.isBuying ? this.app.t('Electricity buying prices') : this.app.t('Electricity selling prices')
  }

  getConfigDefaults(): PortConfigOptimizerPrice {
    return {
    }
  }

  infoTop() : React.ReactNode | undefined {
    const prices = this.port.values.prices || []
    const lines = []
    let last

    const base = DateTime.fromISO(this.port.values.base_ts).toUnixInteger()

    for (let i = 0; i < prices.length; i++) {
      const timestamp = base + i * this.port.values.timestep
      const date = DateTime.fromMillis(timestamp * 1000)
      const day = lang.dayNameAndNumber(date)
      const time = date.toFormat('HH:mm')
      if (!last || last !== day) {
        lines.push(<Box sx={{ my: 1, color: 'primary.main' }}>{day}</Box>)
        last = day
      }
      lines.push(`${time} ${lang.money(prices[i] / 1000, this.app.user?.currency || 'EUR')}`)
    }

    return <Box>
      <Columns columns={4}>
        {lines.map((line, idx) => <Box key={idx}>{line}</Box>)}
      </Columns>
    </Box>
  }
}
